module.exports = __webpack_public_path__ + "img/orange_blob.856092a7.png";